'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { type Ref, useEffect, useImperativeHandle, useRef } from 'react';
import { CompactItineraryScrollerCard } from '~/components/TripOverview/itinerary/CompactItineraryScrollerCard';
import scrollerStyles from '~/components/TripOverview/itinerary/ExpandedItineraryScroller.module.css';
import type { TripAccommodationStay } from '~/services/engine-ts';
import { transformTripAccommodationToStay } from './transformTripAccommodationToStay';
export type AccommodationStaysMapScrollerHandle = {
  scrollToStay: (itemId: number) => void;
};
type AccommodationStaysMapScrollerProps = {
  stays: TripAccommodationStay[];
  activeItemId: number | null;
  onStaySelect: (itemId: number) => void;
  onProgressChange?: (progress: number) => void;
  ref?: Ref<AccommodationStaysMapScrollerHandle>;
};
export const AccommodationStaysMapScroller = t0 => {
  const $ = _c(23);
  const {
    stays,
    activeItemId,
    onStaySelect,
    onProgressChange,
    ref
  } = t0;
  const scrollRef = useRef(null);
  let t1;
  if ($[0] !== onProgressChange || $[1] !== stays) {
    t1 = itemId => {
      const scroller = scrollRef.current;
      if (!scroller) {
        return;
      }
      const index = stays.findIndex(stay => stay.itemId === itemId);
      if (index < 0) {
        return;
      }
      const targetProgress = stays.length < 2 ? 0 : index / (stays.length - 1);
      const max = scroller.scrollWidth - scroller.clientWidth;
      if (max > 0) {
        scroller.scrollTo({
          left: max * targetProgress,
          behavior: "smooth"
        });
        return;
      }
      onProgressChange?.(targetProgress);
    };
    $[0] = onProgressChange;
    $[1] = stays;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const scrollToStay = t1;
  let t2;
  if ($[3] !== scrollToStay) {
    t2 = () => ({
      scrollToStay
    });
    $[3] = scrollToStay;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useImperativeHandle(ref, t2);
  let t3;
  if ($[5] !== onProgressChange) {
    t3 = () => {
      const scroller_0 = scrollRef.current;
      if (!scroller_0 || !onProgressChange) {
        return;
      }
      const compute = () => {
        const max_0 = scroller_0.scrollWidth - scroller_0.clientWidth;
        const progress = max_0 > 0 ? scroller_0.scrollLeft / max_0 : 0;
        onProgressChange(Math.max(0, Math.min(1, progress)));
      };
      compute();
      scroller_0.addEventListener("scroll", compute, {
        passive: true
      });
      return () => scroller_0.removeEventListener("scroll", compute);
    };
    $[5] = onProgressChange;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onProgressChange || $[8] !== stays.length) {
    t4 = [onProgressChange, stays.length];
    $[7] = onProgressChange;
    $[8] = stays.length;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = clsx(scrollerStyles.scrollerClip, scrollerStyles.scrollerClipAccommodation);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = clsx(scrollerStyles.scroller, scrollerStyles.scrollerAccommodation);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== activeItemId || $[13] !== onStaySelect || $[14] !== scrollToStay || $[15] !== stays) {
    let t8;
    if ($[17] !== activeItemId || $[18] !== onStaySelect || $[19] !== scrollToStay) {
      t8 = stay_0 => <CompactItineraryScrollerCard key={stay_0.itemId} item={transformTripAccommodationToStay(stay_0)} isActive={stay_0.itemId === activeItemId} accommodationLabel={{
        hotelName: stay_0.accommodation.title,
        location: stay_0.placeName
      }} data-test-id={`accommodation-map-card-${stay_0.itemId}`} onCardClick={() => {
        scrollToStay(stay_0.itemId);
        onStaySelect(stay_0.itemId);
      }} />;
      $[17] = activeItemId;
      $[18] = onStaySelect;
      $[19] = scrollToStay;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t7 = stays.map(t8);
    $[12] = activeItemId;
    $[13] = onStaySelect;
    $[14] = scrollToStay;
    $[15] = stays;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[21] !== t7) {
    t8 = <div className={t5} data-test-id="accommodation-map-scroller"><div ref={scrollRef} className={t6}>{t7}</div></div>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};